export default __webpack_public_path__ + "static/media/save.16003f80.svg";